import { type InventoryEquipmentTypes, type SetEquippedProps, type SetQuantityProps, type ResetQuantityProps, type CounterEffect, type Storage, type RemoveAllEquipmentProps} from 'src/types'


const setQuantity = (dispatch: (arg0: SetQuantityProps) => void, storage: 'stash' | 'loot' | 'bag', itemID: string, quantity: CounterEffect) => {
  dispatch({
    type: 'SET_QUANTITY',
    storage,
    itemID,
    quantity
  })
}

const resetQuantity = (dispatch: (arg0: ResetQuantityProps) => void, storage: Storage) => {
  dispatch({
    type: 'RESET_QUANTITY',
    storage
  })
}

const setEquipped = (dispatch: (arg0: SetEquippedProps) => void, slot: InventoryEquipmentTypes, itemID: string, equipped: boolean) => {
  dispatch({
    type: 'SET_EQUIPMENT',
    slot,
    itemID,
    equipped
  })
}

const removeAllEquipment = (dispatch: (arg0: RemoveAllEquipmentProps) => void) => {
  dispatch({
    type: 'REMOVE_ALL_EQUIPMENT'
  })
}

export {
  setQuantity,
  setEquipped,
  resetQuantity,
  removeAllEquipment
}
